export const skeletonRows = [0, 1, 2, 3]
